<template>
  <div class="game">
    <div id="head-page" class="globulo parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.3"><img class="" src="@/assets/images/head/sun.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/montagnes.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.2"><img class="" src="@/assets/images/head/sapins.png" alt="" title="" /></div>
        <div id="bg5" data-depth="0.5"><img class="" src="@/assets/images/head/nuages.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page fiche-jeu">
      <div class="grid-x grid-margin-x">
        <div class="small-12 cell">
          <title-page attrpage="Mini jeux" baseline="À toi de jouer !">Pose de voie veineuse centrale</title-page>

          <p>Les médecins peuvent décider de poser un cathéter central aussi appelé voie veineuse
          centrale pour que ça soit plus confortable pour toi et plus facile pour les soignants de faire
          passer les médicaments ou prélever du sang.</p>

          <p>La pose de la voie veineuse centrale se fait au bloc opératoire avec anesthésie générale. Cela
          veut dire que l’on va t’endormir pour la mettre donc tu n’auras pas mal. Certains cathéters
          centraux laissent sortir un petit embout fermé par un bouchon et sont protégés par un
          pansement. D’autres sont sous la forme d’un petit boitier qui reste sous la peau. N’hésite pas
          à regarder les documents sur ce sujet et à poser tes questions à l’équipe médicale si tu as
          besoin.</p>

          <p>Maintenant, aide Globulo à faire passer les médicaments dans tout ton corps grâce à la voie
            veineuse centrale dans ce mini-jeu.</p>

          <div v-if="$isDesktop()" class="box-game">
            <div class="content-game">
              <godot-game
                v-bind="gameInfos"
                @game_finished="endGame"
              />
            </div>
          </div>
          <div v-else>
            <div class="bt-game-mobile chimio">
              <bouton href="/games/decouverte/index.html">Accéder au jeu</bouton>
            </div>
          </div>

          <div class="grid-x grid-margin-x">
            <div class="small-12 cell">
              <h3>Les ressources complémentaires</h3>
            </div>

            <div v-for="fiche in fiches" class="small-12 medium-6 large-4 cell">
              <item-fiche
                :lien="fiche.url"
                :titlebox="fiche.title"
                :type-item="fiche.type">
                {{ fiche.content }}
              </item-fiche>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton.vue'
  import ItemFiche from '@/components/ItemFiche'
  import GodotGame from '@/components/GodotGame'

  import splashFLE from '@/assets/images/games/splash/splash-fle.jpg'
  import splashGame from '@/assets/images/games/splash/splash-voie-veineuse.jpg'

  import FichesDB from '@/datas/fiches'

  export default {
    props: ['gameId'],
    components: { TitlePage, Bouton, ItemFiche, GodotGame },
    data () {
      const me = this.$store.state.me
      const playerInfos = {
        gender: (me.gender === 'H' ? 'boy' : 'girl'),
        playerName: `${me.first_name} ${me.last_name}`,
      }

      return {
        gameInfos: {
          pck: 'jeu-voie-veineuse',
          engineVersion: 'full-3.2.1',
          splashStack: [
            {
              outerBarColor: '#01b1c8',
              innerBarColor: '#e43516',
              backgroundColor: '#FFF',
              duration: 2000,
              splashUrl: splashFLE
            },
            {
              outerBarColor: '#466C91',
              innerBarColor: '#5FABE3',
              backgroundColor: '#000',
              duration: 2000,
              splashUrl: splashGame
            },
          ],
          playerInfos
        },
        fichesIds: [1],
        fiches: []
      }
    },
    computed: {
      currentUser() {
        return this.$store.state.me
      },
    },
    async mounted () {
      const fichesDB = await FichesDB();
      this.fiches =  this.fichesIds.map((fid) => fichesDB.find(f => f.id === fid) )
    },
    methods: {
      endGame() {
        if (this.currentUser.account_type === 'child') {
          this.$store.dispatch('playGame', this.gameId)
        }
      }
    }
  }
</script>
